<template>
  <div class="container">
    <div class="wrapper">
      <ul id="sb-slider" class="sb-slider" :style="{ maxWidth }">
        <li v-for="(item, index) in wallpaper" :key="index">
          <img :src="item" alt="index">
        </li>
      </ul>
      <div id="nav-arrows" class="nav-arrows">
        <left @click="slicebox && slicebox.previous()"/>
        <right @click="slicebox && slicebox.next()"/>
      </div>
    </div>
    <guide-button class="btn-lt" @click="$router.back()">返回</guide-button>
    <div class="btn-rb tips">
      <p>右键另存</p>
      <p>再设壁纸</p>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
require('./libs/jquery.slicebox')

export default {
  name: 'DynamicPicture',
  data () {
    return {
      wallpaper: [],
      maxWidth: '',
      slicebox: null,
    }
  },
  mounted () {
    this.initWallArr()
    this.initStart()
    this.$bgAudio.play()
  },
  beforeDestroy () {
    this.$bgAudio.pause()
  },
  methods: {
    initStart () {
      $(() => {
        const $navArrows = $('#nav-arrows').hide()
        const $shadow = $('#shadow').hide()
        this.slicebox = $('#sb-slider').slicebox({
          onReady: () => {
            $navArrows.show()
            $shadow.show()
            this.maxWidth = '100%'
          },
          orientation: 'r',
          cuboidsRandom: true,
          disperseFactor: 30,
        })
      })
    },
    initWallArr () {
      for (let i = 0; i <= 30; i++) {
        this.wallpaper.push(require(`./wallpapers/${i}.jpg`))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "./scss/slicebox.css";
.nav-arrows {
  .left,
  .right {
    top: 50%;
    transform: translateY(-50%);
  }
  .left {
    left: 0.25rem;
  }
  .right {
    right: 0.25rem;
  }
}
.tips {
  padding: 0.05rem;
  font-size: 0.16rem;
  color: #fff;
  line-height: 1.2;
  background-color: #18437b;
}
</style>
